import { FilterPill } from '@/components/shared/FilterPill';
import { Box, BoxProps, Typography } from '@mui/material';
import { useAtomValue, useSetAtom } from 'jotai';
import * as state from '@/components/Analysis/modules/CustomBlocks/state';
import { useEffect, useState } from 'react';
import * as globalState from '@/components/Analysis/state';

type Props = {
  sx?: BoxProps['sx'];
  BoxProps?: BoxProps;
};

export const CustomBlockFilterChips = ({ sx, BoxProps }: Props) => {
  const setCustomBlockQueryFilters = useSetAtom(state.customBlockQueryFilters);
  const isSavedBlocksSelected = useAtomValue(globalState.isSavedBlocksSelected);

  const [yetToBeScoped, setYetToBeScoped] = useState(true);
  const [scoped, setScoped] = useState(false);

  useEffect(() => {
    const newExcludeAlreadyPlannedBlocksInput = (() => {
      if (yetToBeScoped) {
        return true;
      }
      if (scoped) {
        return false;
      }

      return undefined;
    })();

    setCustomBlockQueryFilters((prev) => ({
      ...prev,
      excludeAlreadyPlannedBlocks: newExcludeAlreadyPlannedBlocksInput,
    }));
  }, [scoped, yetToBeScoped, setCustomBlockQueryFilters]);

  // Weird logic to make sure both filters are not selected at the same time
  const toggleHandler = (source: 'yetToBeScoped' | 'scoped') => {
    if (source === 'yetToBeScoped') {
      if (!yetToBeScoped) {
        setScoped(false);
      }
      setYetToBeScoped(!yetToBeScoped);
    } else {
      if (!scoped) {
        setYetToBeScoped(false);
      }
      setScoped(!scoped);
    }
  };

  // Do not show the component if
  if (isSavedBlocksSelected) return <></>;

  return (
    <Box
      {...BoxProps}
      sx={{
        ...sx,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 1,
      }}
    >
      <Typography>Show:</Typography>
      <FilterPill
        label="Yet to be scoped"
        selected={yetToBeScoped}
        onClick={() => toggleHandler('yetToBeScoped')}
      />
      <FilterPill label="Scoped" selected={scoped} onClick={() => toggleHandler('scoped')} />
    </Box>
  );
};
